<template>
  <v-dialog v-model="visible" max-width="600" persistent>
    <v-form v-model="valid" ref="form">
      <v-card>
        <v-card-title v-text="model.id ? 'Edit Agenda' : 'Agenda Baru'" />
        <v-card-text>
          <v-container grid-list-xl>
            <v-layout>
              <v-row>
                <v-col class="py-1" cols="12">
                  <v-text-field
                    v-model="model.nama_agenda"
                    label="Nama Acara"
                    :rules="nonEmptyRule"
                    :error="errors.has('nama_agenda')"
                    :error-messages="errors.get('nama_agenda')"
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" cols="12">
                  <v-text-field
                    v-model="model.pengundang"
                    label="Yang Mengundang / Pemilik Acara"
                    :rules="nonEmptyRule"
                    :error="errors.has('pengundang')"
                    :error-messages="errors.get('pengundang')"
                  ></v-text-field>
                </v-col>
                <v-col class="py-1" cols="12">
                  <v-text-field
                    v-model="model.tempat"
                    :rules="nonEmptyRule"
                    label="Lokasi Acara"
                  ></v-text-field>
                </v-col>
                <v-col class="py-1 mt-2" cols="6">
                  <v-menu
                    close-on-content-click
                    transition="scale-transition"
                    :nudge-right="40"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="model.tgl"
                        :rules="nonEmptyRule"
                        label="Tanggal Agenda"
                        placeholder="Pilih Tanggal"
                        prepend-icon="mdi-calendar-range"
                        readonly
                        v-on="on"
                        :error="errors.has('tgl')"
                        :error-messages="errors.get('tgl')"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.tgl"
                      :max="model.tgl_selesai"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-1 mt-2" cols="6">
                  <v-menu
                    close-on-content-click
                    transition="scale-transition"
                    :nudge-right="40"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="model.tgl_selesai"
                        label="Sampai Tanggal"
                        placeholder="Pilih Tanggal"
                        prepend-icon="mdi-calendar-range"
                        readonly
                        v-on="on"
                        :error="errors.has('tgl_selesai')"
                        :error-messages="errors.get('tgl_selesai')"
                        clearable
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="model.tgl_selesai"
                      :min="model.tgl"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="py-1 picker-container" xs12 md6>
                  <label class="picker-label" for="waktu">Waktu Mulai</label>
                  <datepicker
                    v-model="model.waktu"
                    placeholder="HH:mm"
                    type="time"
                    :minute-step="5"
                    format="HH:mm"
                    value-type="format"
                    :input-class="{
                      'mx-input': true,
                      'error-input': errors.has('waktu')
                    }"
                    @change="errors.clear('waktu')"
                  >
                    <template slot="icon-calendar">
                      <v-icon small>mdi-clock-outline</v-icon>
                    </template>
                  </datepicker>
                  <span class="error-helper">{{ errors.get('waktu') }}</span>
                </v-col>
                <v-col class="py-1 picker-container" xs12 md6>
                  <label class="picker-label" for="waktu">Sampai dendan</label>
                  <datepicker
                    v-model="model.waktu_selesai"
                    placeholder="HH:mm"
                    type="time"
                    :minute-step="5"
                    format="HH:mm"
                    value-type="format"
                    :input-class="{
                      'mx-input': true,
                      'error-input': errors.has('waktu_selesai')
                    }"
                    @change="errors.clear('waktu_selesai')"
                  >
                    <template slot="icon-calendar">
                      <v-icon small>mdi-clock-outline</v-icon>
                    </template>
                  </datepicker>
                  <span class="error-helper">{{
                    errors.get('waktu_selesai')
                  }}</span>
                </v-col>
              </v-row>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            @click="closeForm"
            :disabled="loading"
          >
            Batal
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="onSubmit"
            :loading="loading"
            v-text="model.id ? 'Perbaharui Agenda' : 'Simpan Agenda'"
          />
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Errors from '@/utils/errors'
import { mapGetters } from 'vuex'
import { addAgenda, updateAgenda } from '@/services/agenda'
import moment from 'moment'

const initialModel = {
  tgl: '',
  waktu: '',
  tgl_selesai: '',
  waktu_selesai: '',
  tempat: '',
  nama_agenda: '',
  pengundang: ''
}

export default {
  name: 'agenda-form',
  data() {
    return {
      valid: false,
      visible: false,
      model: { ...initialModel },
      nonEmptyRule: [v => !!v || 'tidak boleh kosong'],
      errors: new Errors(),
      loading: false
    }
  },
  computed: {
    ...mapGetters(['isStaff'])
  },
  methods: {
    showForm() {
      this.visible = true
    },
    closeForm() {
      this.resetForm()
      this.visible = false
    },
    editAgenda(agenda = initialModel) {
      const {
        tgl,
        waktu,
        tgl_selesai,
        waktu_selesai,
        tempat,
        nama_agenda,
        pengundang,
        id
      } = agenda
      this.visible = true
      this.model = {
        tgl,
        waktu: waktu ? moment(waktu, 'HH:mm:ss').format('HH:mm') : null,
        tgl_selesai,
        waktu_selesai: waktu_selesai
          ? moment(waktu_selesai, 'HH:mm:ss').format('HH:mm')
          : null,
        tempat,
        nama_agenda,
        pengundang,
        id
      }
    },
    validate() {
      const validate = this.$refs.form.validate()
      return validate
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
      this.recordErrors({})
      this.model = { ...initialModel }
    },
    recordErrors(errors = {}) {
      this.errors.record(errors)
    },
    async onSubmit() {
      if (!this.validate()) return
      try {
        this.loading = true

        const { id, ...model } = this.model

        let data = {}
        Object.keys(model).forEach(k => {
          const item = this.model[k]
          if (id) {
            data[k] = item
          } else {
            if (item) {
              data[k] = item
            }
          }
        })

        if (id) {
          await updateAgenda(id, data)
        } else {
          await addAgenda(data)
        }

        this.visible = false
        this.$emit('submited')
      } catch (error) {
        this.recordErrors(error.data || {})
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.picker-container {
  padding-left: 2.8rem !important;
  margin-bottom: 0.5rem;
}
</style>
